import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  tableRow: {
    background: theme.palette.background.default,
    '& > *': {
      borderColor: theme.palette.input.border,
      borderWidth: 1,
      borderStyle: 'solid'
    }
  },
  tableCell: { verticalAlign: 'top' },
  containerItems: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: 4,
  },
  row2: {
    width: 200,
    '&>*': { minHeight: theme.spacing(4), }
  },
  cell1: {
    width: '35%',
    verticalAlign: 'middle'
  },
  cell2: { width: '65%', },
  mobileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.border.line,
  },
  mobileLabel: {
    color: theme.palette.primary.light,
    fontWeight: 500,
    overflowWrap: 'anywhere',
  },
  mobileValue: {
    width: '100%',
    minWidth: 0,
  },
}));

type ProjectedPaymentsTableProps = {
  data: string[];
  rows: any;
  isMobile?: boolean;
  idPrefix?: string;
};

const ProjectedPaymentsTable = ({
  data, rows, isMobile = false, idPrefix = 'projected-payments'
}: ProjectedPaymentsTableProps) => {
  const classes = useStyles();
  if (isMobile) {
    return (
      <Box className={classes.mobileList}>
        {data.map((field) => {
          const titleId = `${idPrefix}-${field}-title`;
          return (
            <Paper
              key={field}
              variant="outlined"
              role="group"
              aria-labelledby={titleId}
              className={classes.mobileCard}
            >
              <Typography id={titleId} className={classes.mobileLabel}>
                {rows[field]?.title}
              </Typography>
              <Box className={classes.mobileValue}>{rows[field]?.render}</Box>
            </Paper>
          );
        })}
      </Box>
    );
  }
  return (
    <TableContainer>
      <Table>
        <TableBody>
          {data.map((field) => (
            <TableRow key={field} className={classes.tableRow}>
              <TableCell component="th" scope="row" className={`${classes.tableCell} ${classes.row2} ${classes.cell1}`}>
                <Typography>{rows[field]?.title}</Typography>
              </TableCell>

              <TableCell component="th" scope="row" className={`${classes.tableCell} ${classes.row2} ${classes.cell2}`}>
                {rows[field]?.render}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProjectedPaymentsTable;
